import React from 'react'
import './Header.css'
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';

import { Link } from 'react-router-dom';
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";

export default function Header() {
    const [{ basket, user }, dispatch] = useStateValue();

  const handleAuthenticaton = () => {
    if (user) {
      auth.signOut();
    }
  }
    return (
        <div className='header'>
            <Link to = "/">
            <img className="header_logo" src="https://pngimg.com/uploads/amazon/amazon_PNG11.png"/>
            </Link>
            <div className="header_basket">
            <RoomOutlinedIcon  className="shoppingcart"/>
                </div>
            
            <div className="header_option">
                    
                    <span className="header_optionLineone">Hello</span>
                    <span className ="header_optionLinetwo "> Select your location</span>
                </div>

            <div className="header_search">
                <input className="header_input" type="text"/>
                <SearchIcon className="header_searchicon" />

            </div>
            <div className="header_nav">
            <Link to={!user && '/login'}>
          <div onClick={handleAuthenticaton} className="header_option">
            <span className="header_optionLineone">Hello, {!user ? 'Sign In' : user.email}</span>
            <span className="header_optionLinetwo">{user ? 'Sign Out' : 'Account & Lists'}</span>
          </div>
        </Link>
        <Link to='/orders'>
               <div className ="header_option">
                   <span className ="header_optionLineone"> Return  </span>
                   <span className ="header_optionLinetwo"> & Orders </span>
                </div> 
                </Link>
                <Link  to ="/checkout">
                <div className="header_basket">
                    <ShoppingCartIcon  className="shoppingcart"/>
                    <span className ="header_optionLinetwo header_basketcount"> {basket?.length}</span>
                </div>
                </Link>
            </div>
        </div>
    )
}
